import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';

import {
  CADENCE_VERBOSE_STRING,
  BATCH_RENEWAL_COMPONENT_CONTEXT,
} from 'utils/subscriptions';
import styles from './BatchAndRenewalNotification.module.scss';

const formatDate = (date) => moment(date).format('MMMM D');

const BatchAndRenewalNotification = ({
  shippingDate,
  cadenceType,
  context,
}) => {
  const isCheckoutContext =
    context === BATCH_RENEWAL_COMPONENT_CONTEXT.checkout;
  return (
    <div
      className={classNames(styles.container, styles[context])}
      data-testid="batch-and-renewal-notification"
    >
      <p>
        {isCheckoutContext && <strong>Note: </strong>}Your first order will ship
        immediately. Your next order ships with your existing subscription(s)
        processing on {formatDate(shippingDate)} and every{' '}
        {CADENCE_VERBOSE_STRING[cadenceType]} thereafter.
      </p>
    </div>
  );
};

BatchAndRenewalNotification.propTypes = {
  shippingDate: PropTypes.string.isRequired,
  cadenceType: PropTypes.string.isRequired,
  context: PropTypes.string.isRequired,
};

export default BatchAndRenewalNotification;
